import { v4 as uuidv4 } from 'uuid';

export function MinicartBaseContent(props, childrenComponents = [], blocks = []) {
	return {
		componentName: 'MinicartBaseContent',
		componentId: uuidv4(),
		draggableType: 'Container',
		droppableType: 'NONE',
		props,
		childrenComponents,
		blocks,
	};
}
